import { useParams } from "react-router-dom";
import { getDesignPDF } from "../../../api/editor.api";
import { useState } from "react";

const DownloadPDF = () => {
  const { designId } = useParams(); // Extract `designId` from the URL
  const [isDownloading, setIsDownloading] = useState(false);
  const handlePrintPDF = async () => {
    if (!designId) return; // Ensure `designId` exists

    try {
      setIsDownloading(true);
      const pdfData = await getDesignPDF(designId); // Use getDesignPDF to fetch the PDF
      setIsDownloading(false);
      const pdfBlob = new Blob([pdfData], { type: "application/pdf" }); // Create a Blob from the data
      const pdfURL = URL.createObjectURL(pdfBlob); // Create a URL for the PDF Blob

      // Open the PDF in a new tab for printing
      const pdfWindow = window.open();
      if (pdfWindow) {
        pdfWindow.location.href = pdfURL;
      }
    } catch (error) {
      console.error("Error fetching the PDF:", error);
    }
  };

  return (
    <div className="px-5">
      <div className="text-center text-2xl font-bold mb-2">
        Get Your PDF Proof
      </div>
      <div className="text-grey mb-5">
        To make sure your order comes out inst the way you want it, get a PDF
        proof to print and review. Please remember to double-check your
        spelling, text size and alignment before placing your order. You can
        also expect a degree of slight variation as the precision and quality of
        our commercial engravers is much higher than most.
      </div>
      <button
        onClick={handlePrintPDF}
        className="max-sm:w-full w-[50%] text-center block bg-primaryred text-white font-bold	text-xl py-2 px-7 rounded-full mx-auto my-4"
      >
        {isDownloading ? "Downloading.." : "Download The PDF"}
      </button>
    </div>
  );
};
export default DownloadPDF;
